module.exports = __webpack_public_path__ + "static/media/edit.0a6bbe6d.svg";